<template>
    <span v-if="quantity === 0">
        <b-badge
            variant="danger"
            :aria-label="'Out of stock'"
        >
            <i class="mdi mdi-close-circle"></i> Out of stock
        </b-badge>
    </span>
    <span v-else-if="quantity <= lowThreshold">
        <b-badge
            variant="warning"
            :aria-label="quantity + ' units remaining'"
        >
            <i class="mdi mdi-alert-circle"></i> {{ quantity }} left
        </b-badge>
    </span>
    <span v-else-if="showInStock" class="stock-badge-in-stock">
        In stock
    </span>
</template>

<script>
export default {
    name: "stockBadge",
    props: {
        quantity: {
            type: Number,
            required: true,
        },
        lowThreshold: {
            type: Number,
            default: 5,
        },
        showInStock: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped lang="scss">
@import "~@/design/tokens/surfaces";

.stock-badge-in-stock {
    color: $text-secondary;
    font-size: 0.85em;
}
</style>
